export default "__VITE_ASSET__B0_T_bTz__"